

















import {
  defineComponent,
  computed,
  ref,
} from '@vue/composition-api';

import { BASE_VEHICLE } from '@/useDeliveryNote';

const WeightDisplay = defineComponent({
  props: {
    vehicle: { default: () => ({ ...BASE_VEHICLE }) },
    carryWeight: { default: 0.00 },
    packagesPrice: {},
    volume: { default: 0 },
    showWeightProperty: { default: true },
  },
  setup(props) {
    const toCurrency = (string: string) => parseFloat(string || '0').toLocaleString('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const weightStatus = ref('');
    const computedCarryWeight = computed(() => {
      // If There is no weight
      if (props.carryWeight <= 0) {
        weightStatus.value = '';
        return [{ data: 0, color: 'pink' }, { data: 230, color: 'light-gray' }];
      }
      // If Weight less than minimum
      if (props.carryWeight < props.vehicle.minWeight) {
        weightStatus.value = 'น้ำหนักต่ำกว่าเกณฑ์';
        return [
          { data: props.carryWeight, color: 'yellow' },
          { data: props.vehicle.minWeight - props.carryWeight, color: 'light-gray' },
          { data: props.vehicle.maxWeight - ((props.carryWeight) + (props.vehicle.minWeight - props.carryWeight)), color: 'light-gray' },
        ];
      }
      if (props.carryWeight === props.vehicle.minWeight) {
        weightStatus.value = 'น้ำหนักผ่านเกณฑ์';
        return [
          { data: props.carryWeight, color: 'green' },
          { data: props.vehicle.maxWeight - (props.carryWeight), color: 'light-gray' },
          { data: props.carryWeight - props.vehicle.legalWeight, color: 'light-gray' },
        ];
      }
      // If Weight greater than minimum & weight less than legal weight
      if (props.carryWeight > props.vehicle.minWeight && props.carryWeight > props.vehicle.legalWeight) {
        weightStatus.value = 'น้ำหนักผิดกฎหมาย';
        return [
          { data: props.carryWeight, color: 'red' },
          { data: props.carryWeight - props.vehicle.minWeight, color: 'red' },
          { data: props.vehicle.maxWeight - (props.carryWeight + props.vehicle.minWeight), color: 'light-gray' },
          { data: props.carryWeight - props.vehicle.legalWeight, color: 'red' },
        ];
      }

      // If Weight greater than minimum & weight greater than legal weight
      if (props.carryWeight > props.vehicle.minWeight && props.carryWeight > props.vehicle.legalWeight) {
        weightStatus.value = 'น้ำหนักผ่านเกณฑ์';
        return [
          { data: props.carryWeight, color: 'green' },
          { data: props.carryWeight - props.vehicle.minWeight, color: 'green' },
          { data: props.vehicle.maxWeight - (props.carryWeight + props.vehicle.minWeight), color: 'light-gray' },
          { data: props.vehicle.legalWeight - (props.carryWeight + (props.carryWeight - props.vehicle.minWeight) + props.vehicle.maxWeight - (props.carryWeight + props.vehicle.minWeight)), color: 'orange' },
        ];
      }
      weightStatus.value = '';
      return [
        { data: props.carryWeight, color: 'green' },
        { data: props.vehicle.maxWeight - props.carryWeight, color: 'light-gray' },
      ];
    });

    return {
      toCurrency,
      weightStatus,
      computedCarryWeight,
    };
  },
});

export default WeightDisplay;
